import { apiSlice } from './apiSlice';

export interface FileItem {
  id: number;
  name: string;
  category: string;
  path: string;
  url: string;
  status: string;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface FileHistoryResponse {
  count: number;
  data: FileItem[];
}
export interface DashboardResponse {
  total: number;
  tech: number;
  semiTech: number;
  nonTech: number;
}

export const filesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFileHistory: builder.query<
      FileHistoryResponse,
      { category?: string; fromDate?: string; toDate?: string; skip?: number; take?: number }
    >({
      query: ({ category, fromDate, toDate, skip, take }) => ({
        url: '/file-data',
        params: {
          ...(category && category !== 'all' && { category }),
          ...(fromDate && { fromDate }),
          ...(toDate && { toDate }),
          ...(skip !== undefined && { skip }),
          ...(take !== undefined && { take }),
        },
      }),
      providesTags: ['Files'],
    }),
    updateFileStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/${id}`,
        method: 'PATCH',
        body: { status },
      }),
      invalidatesTags: ['Files'],
    }),

    deleteFile: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Files'],
    }),
    getDashboardStats: builder.query<DashboardResponse, void>({
      query: () => ({
        url: '/file-data/count',
        method: 'GET',
      }),
      // providesTags: ['Files'],
    }),
  }),
});

export const {
  useGetFileHistoryQuery,
  useUpdateFileStatusMutation,
  useDeleteFileMutation,
  useGetDashboardStatsQuery,
} = filesApi;
